import utils from '@digabi/js-utils/dist/client-utils'

export default utils({})
